class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
    const cartLink1 = document.querySelector('#cart-icon-bubble1');
    cartLink1.setAttribute('role', 'button');
    cartLink1.setAttribute('aria-haspopup', 'dialog');
    cartLink1.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink1)
    });
    cartLink1.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink1);
      }
    });
  }

  open(triggeredBy) {
    // Custom Js Code To remove coupon Text
    $("div[candyrack-cart-info]").remove();
    // Custom Js Code To remove coupon Text Ends
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Custom Code For Cart Drawer =======
$(document).ready(function() {
  var intervalId = setInterval(function() {
    // Check if the div with candyrack-cart-info exists
    var div = $('div[candyrack-cart-info]');
    if (div.length > 0) {
        var div_value = div.html();
        var text = $('div[candyrack-cart-info]').text();
        var div_discount = text.match(/\d+/);
        if (div_discount) {
            div_discount = parseInt(div_discount[0], 10);
            console.log('Discount:', div_discount); // Logs 75
        }
        // Get the closest <td> to the div
        var td = div.closest('td');
        
        // Find the next <td>, hide the <span class="price">, and display "$0"
        var priceSpan = td.next('td').find('span.price');
        
        if (priceSpan.length > 0) {
           priceSpan.css({
               'text-decoration-line': 'line-through',
               'margin': '0 8px 0 0'
            });
            // Get the value inside the .totals__subtotal-value <p> (e.g., $179.95 USD)
            var subtotalText = $('.totals__subtotal-value').text();
            
            // Extract numeric value from the subtotal (removing "$" and "USD")
            var subtotalValue = parseFloat(subtotalText.replace(/[^0-9.-]+/g, ""));
            
            // Extract price from the priceSpan (assuming format like "$19.99")
            var priceText = priceSpan.text();
            var priceValue = parseFloat(priceText.replace(/[^0-9.-]+/g, ""));
            
            // Subtract the price from the subtotal
            var newSubtotal = subtotalValue - priceValue;
            
            // Update the .totals__subtotal-value with the new value
            $('.totals__subtotal-value').text('$' + newSubtotal.toFixed(2) + ' USD');
            
            // Hide the original price
            // priceSpan.hide();
            
            // Add "$0" price if not already added
            if (td.next('td').find('.price').length === 1) {
                td.next('td').append('<span class="price" style="color:red">$0.00</span>');
            }
            
            // Stop the interval once "$0" has been appended
            clearInterval(intervalId);
        }

        // Example: Change the background color of the <td>
        td.css('background-color', 'lightyellow');
    } else {
        console.log("The div with candyrack-cart-info does not exist.");
    }
  }, 1000); // Run the code every 2 seconds
});
